export default __webpack_public_path__ + "static/media/logo_negro.5b5901c2.png";